import { nativeEnum, object, string, z } from 'zod';

export const emissionFactorSchema = object({
  value: z.union([z.number(), z.string()]).optional(),
  source: string().nullish(),
  method: nativeEnum({
    standard: 'standard',
    custom: 'custom',
  })
    .default('standard')
    .optional(),
});

export const emissionFactors = object({
  farming: emissionFactorSchema.optional(),
  processing: emissionFactorSchema.optional(),
  packaging: emissionFactorSchema.optional().nullish(),
  transport: emissionFactorSchema.optional(),
}).optional();

export type EmissionsFactorSchema = z.infer<typeof emissionFactorSchema>;
export type EmissionFactorsSchema = z.infer<typeof emissionFactors>;
